<!-- todo: get rid of wrapping anchor tag. just use click and link inside-->

<ng-template #content>
  <picture
    class="anchor-card__image"
    [paiPicture]="image"
    [mode]="imageOptions()?.objectFit"
    [ratio]="imageOptions()?.ratio"
    sizeSm="100vw"
    [size]="parentLayout().maxWidthAtMd"
    [sizeLg]="parentLayout().maxWidthAtLg"
    [sizeXl]="parentLayout().maxWidthAtXl"
  ></picture>
  <h3 class="anchor-card__title">{{ title }}</h3>
  @if (date) {
    <div class="anchor-card__date">{{ date | date: 'mediumDate' }}</div>
  }
  <p class="anchor-card__text" [innerText]="text ?? ''"></p>
  @if ((isInternalLink || isExternalLink) && ctaKey && ctaIcon) {
    <div class="anchor-card__cta" aria-hidden="true">
      <span>{{ ctaKey | translate }}</span>
      <pai-icon class="anchor-card__cta-icon" [icon]="ctaIcon" />
    </div>
  }
</ng-template>

<!-- NO Link -->
<ng-template #noLinkTpl>
  <div class="anchor-card">
    <ng-container *ngTemplateOutlet="content" />
  </div>
</ng-template>

<!-- CMS Link -->
<ng-template #internalLinkTpl>
  <a
    class="anchor-card"
    [paiCmsLink]="internalLink"
    [keepQueryParams]="preserveQueryParams"
    [attr.aria-label]="title"
    paiRipple
  >
    <ng-container *ngTemplateOutlet="content" />
  </a>
</ng-template>

<!-- external url Link -->
<ng-template #externalLinkTpl>
  <a class="anchor-card" [href]="externalLink" target="_blank" [attr.aria-label]="title" paiRipple>
    <ng-container *ngTemplateOutlet="content" />
  </a>
</ng-template>

<ng-template [ngTemplateOutlet]="isInternalLink ? internalLinkTpl : isExternalLink ? externalLinkTpl : noLinkTpl" />
